// extracted by mini-css-extract-plugin
export default {"home":"AddExam_home__v8ToG","hr":"AddExam_hr__Zg58g","main":"AddExam_main__xCstq"};